import DesignBox from "@/assets/svgs/DesignBox";
import PurpleBg from "@/assets/svgs/PurpleBg";
import Settings from "@/assets/svgs/Settings";
import Star from "@/assets/svgs/Star";
import React from "react";
import { FeaturesType } from "./ComparisonFeaturesWithCta";

type ComparisonCardsDetailedProps = {
  competitorLogo: string;
  graphyHeader: string;
  graphyFeatures: FeaturesType[];
  competitorHeader: string;
  competitorFeatures: FeaturesType[];
  isRight: boolean;
  emoji: string;
};

const ComparisonCardsDetailed: React.FC<ComparisonCardsDetailedProps> = ({
  competitorLogo,
  emoji,
  graphyHeader,
  graphyFeatures,
  competitorHeader,
  competitorFeatures,
  isRight,
}) => {
  return (
    <div
      className={`flex w-full justify-center
      `}
    >
      <div className="relative mt-14 h-fit  w-1/2 gap-2.5  rounded-xl border  border-grey-3 bg-white px-3 py-4 md:mt-4 md:p-6 xl:shadow-dark">
        <div
          className={` ${
            !isRight
              ? "right-48 hidden  md:-left-7 md:top-2  md:block"
              : "-top-8 left-9 md:-left-8 md:-top-8"
          }  absolute -z-30 flex h-44 w-44`}
        >
          {isRight ? <Settings /> : <Star />}
        </div>
        <div className="absolute -top-9 left-[calc(100%_-_32px)] z-30 flex h-16 w-16 items-center justify-center rounded-full bg-white text-3xl shadow-md xl:-top-8 xl:flex ">
          {emoji}
        </div>
        <p className="mb-3 text-center font-semibold text-grey-4">
          {competitorHeader}
        </p>
        <img
          src={competitorLogo}
          alt="Competitor Logo"
          width={130}
          className="mx-auto mb-6"
        />
        <div className="flex flex-col items-center justify-center gap-[15px]">
          {competitorFeatures.map(({ heading, highlight, subheading }, idx) => (
            <div
              className="flex w-full flex-col items-center gap-3  md:flex-row md:items-start "
              key={idx}
            >
              <div className="flex flex-col gap-2">
                <p className="text-title-14 font-semibold">{heading}</p>
                <p className="text-body-14 text-grey-4 sm:text-sm md:text-start whitespace-pre-line">
                  {highlight && (
                    <span className="font-semibold">{highlight}</span>
                  )}{" "}
                  {subheading}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="absolute -bottom-12 -right-36 -z-50  md:-right-36 md:top-56">
          <PurpleBg />
        </div>
      </div>

      <div
        className="xl:shadow-above md:-left-15  bottom-shadow-purple-xl relative 
      h-fit w-1/2 rounded-xl border border-purple-3 bg-white px-3 
      py-8  md:px-6 md:py-8"
      >
        <p className="mb-3 text-center font-semibold text-grey-4">
          {graphyHeader}
        </p>
        <img
          src="/images/graphy-logo.svg"
          alt="Graphy Logo"
          className="mx-auto mb-6"
          width={100}
        />
        <div className="flex flex-col items-center justify-center gap-4">
          {graphyFeatures.map(({ heading, highlight, subheading }, idx) => (
            <div
              className="flex w-full flex-col items-center gap-3  md:flex-row md:items-start "
              key={idx}
            >
              <div className="flex flex-col gap-2">
                <p className="text-title-14 font-semibold">{heading}</p>
                <p className="text-body-14 text-grey-4 sm:text-sm md:text-start whitespace-pre-line">
                  {subheading}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="absolute -top-20 right-0 -z-50 md:-top-20 md:right-20">
          <DesignBox />
        </div>
      </div>
    </div>
  );
};
export default ComparisonCardsDetailed;
